/**
 * Sticky Add to Cart Behavior
 * - Hides on page load
 * - Reveals slowly on scroll
 * - Hides when product__submit__holder is visible
 */
(function() {
  'use strict';

  // Wait for DOM to be ready
  function init() {
    const stickyCart = document.querySelector('.sticky-add-to-cart-wrap');
    const submitHolder = document.querySelector('.product__submit__holder');

    let hasShown = false;

    // Exit if sticky cart doesn't exist (e.g., on desktop where it's hidden)
    if (!stickyCart) return;

    // Initial state: hide on page load
    stickyCart.style.opacity = '0';
    stickyCart.style.visibility = 'hidden';
    stickyCart.style.transition = 'opacity 0.3s ease-in-out, visibility 0.3s ease-in-out';

    let scrollThreshold = 100; // Start revealing after 300px scroll
    let hasScrolled = false;

    // Function to check if submit holder is visible
    function checkSubmitHolderVisibility() {
      if (!submitHolder) return false;

      const rect = submitHolder.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      
      // Check if element is in viewport (visible)
      return (
        rect.top >= 0 &&
        rect.top <= windowHeight &&
        rect.bottom >= 0 &&
        rect.bottom <= windowHeight
      ) || (
        rect.top < windowHeight && rect.bottom > 0
      );
    }

    // Function to show sticky cart
    function showStickyCart() {
      if (!checkSubmitHolderVisibility()) {
        if (!hasShown) {
          hasShown = true;
          stickyCart.style.opacity = '1';
          stickyCart.style.visibility = 'visible';
        }
      }
    }

    // Function to hide sticky cart
    function hideStickyCart() {
      if (hasShown) { return; }
      stickyCart.style.opacity = '0';
      stickyCart.style.visibility = 'hidden';

    }

    // Scroll event handler
    function handleScroll() {
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;

      // Check if submit holder is visible first
      if (checkSubmitHolderVisibility()) {
        hideStickyCart();
        return;
      }

      // Reveal sticky cart after scroll threshold
      if (scrollY > scrollThreshold) {
        if (!hasScrolled) {
          hasScrolled = true;
        }
        showStickyCart();
      } else {
        hideStickyCart();
        hasScrolled = false;
      }
    }

    // Use IntersectionObserver for better performance when checking submit holder visibility
    let submitHolderObserver;
    if (submitHolder && 'IntersectionObserver' in window) {
      submitHolderObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            // Submit holder is visible, hide sticky cart
            hideStickyCart();
          } else {
            // Submit holder is not visible, check scroll position
            const scrollY = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollY > scrollThreshold) {
              showStickyCart();
            }
          }
        });
      }, {
        threshold: 0.1, // Trigger when 10% of element is visible
        rootMargin: '0px'
      });

      submitHolderObserver.observe(submitHolder);
    }

    // Throttle scroll events for better performance
    let ticking = false;
    function requestTick() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    }

    // Listen to scroll events
    window.addEventListener('scroll', requestTick, { passive: true });

    // Initial check on load
    handleScroll();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
